import { jsx as _jsx } from "react/jsx-runtime";
import { Input as HeroInput } from '@heroui/react';
export const Input = (props) => {
    return _jsx(HeroInput, { ...props });
};
//# sourceMappingURL=Input.js.map